import axios from 'axios';
import React from 'react';
import Properties from "../const/Properties";
import CustomModal from "../thema/tema1/component/CustomModal";
import Footer from "../thema/tema1/component/Footer";
import Header from "../thema/tema1/component/Header";
import PageContext from "../thema/tema1/component/PageContext";
import SideMenu from "../thema/tema1/component/SideMenu";
import {withRouter} from 'react-router-dom';

const active = {Home: "active"};
const gidecegiUlkeEnum = {
    1: "TRİESTE",
    2: "BARİ",
};
const geldigiGumruk = {
    1: "ESENDERE",
    2: "DİLUCU",
    3: "GÜRBULAK",
};

class BilgiGirisPopup extends React.Component {
    constructor(props) {
        super(props);
        if (localStorage.getItem("token") == "") {
            window.location = '/';
            return false;
        }
        this.state = {
            tasimaId: localStorage.getItem("tasimaId"),
            surucuAdi: "",
            karneNumarasi: "",
            pasaportNumarasi: "",
            geldigiGumruk: "",
            gemiAdi: "",
            muhurNumarasi: "",
            ttNumarasi: "",
            gidecegiUlke: "",
            kapAdeti: 0,
            kg: 0,
            yukCinsi: "",
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            aciklama: "",
            silModal: 'none',
            title: ["STATU", "TARİH", "ÇEKİCİ PLAKA", "İŞLEM ÜCRETİ", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.get();
    }

    componentDidMount() {

    }
    makbuzYazdir = (e) => {
        const popupWin = window.open('', '_blank');
        popupWin.document.open();
        let gidecegiUlke = 0;
        let gidecegiUlkeStr = "";
        let ttnumarasi = "";
        let surucuadi = "";
        let karnenumarasi = "";
        let pasaportnumarasi = "";
        let geldigigumruk = "";
        let gemiadi = "";
        let muhurnumarasi = "";
        let kapadeti = 0;
        let kg = 0;
        let yukcins  = "";
        let plaka  = "";
        let firma  = "";
        let tarih  = "";
        let geldigigumrukStr  = "";
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tasima/get/'+this.state.tasimaId,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                console.log(res.data);
                firma = res.data.firmaAdi;
                tarih = res.data.tarih;
                plaka = res.data.cekiciPlaka + " / " + res.data.dorsePlaka;
                gidecegiUlke = res.data.gidecegiUlke ? res.data.surucuAdi : '';
                ttnumarasi = res.data.ttNumarasi ? res.data.ttNumarasi : '';
                surucuadi = res.data.surucuAdi ? res.data.surucuAdi : '';
                karnenumarasi = res.data.karneNumarasi ? res.data.karneNumarasi : '';
                pasaportnumarasi = res.data.pasaportNumarasi ? res.data.pasaportNumarasi : '';
                geldigigumruk = res.data.geldigiGumruk ? res.data.geldigiGumruk : '';
                gemiadi = res.data.gemiAdi ? res.data.gemiAdi : '';
                muhurnumarasi = res.data.muhurNumarasi ? res.data.muhurNumarasi : '';
                kapadeti = res.data.kapAdeti ? res.data.kapAdeti : '';
                kg = res.data.kg ? res.data.kg : '';
                yukcins = res.data.yukCinsi ? res.data.yukCinsi : '';
                if (gidecegiUlke == 1) {
                    gidecegiUlkeStr = "Trieste";
                } else if (gidecegiUlke == 2) {
                    gidecegiUlkeStr = "Bari";
                } else if (gidecegiUlke == 3) {
                    gidecegiUlkeStr = "Sete";
                }
                if (geldigigumruk == 1) {
                    geldigigumrukStr = "ESENDERE";
                } else if (geldigigumruk == 2) {
                    geldigigumrukStr = "DİLUCU";
                } else if (geldigigumruk == 3) {
                    geldigigumrukStr = "GÜRBULAK";
                }
                else
                {
                    geldigigumrukStr = " ";
                }
                popupWin.document.write(`
    <html>
<!-- Google Font: Source Sans Pro -->
<style>
body{
font-size: 12px;
}
    .logo{
        margin-top: 40px;
        position: absolute;
        width: 150px;
        margin-left: -50px;
    }

    .years20{
        margin-top: 30px;
        position: absolute;
        margin-left: 550px;
    }
    .title{
        margin-top: 97px;
        position: absolute;
        margin-left: 357px;
    }
    .years20 img{
        width: 150px;
    }
    .firma{
    position: absolute;
        margin-top: 250px;
    }
    .plaka{
    position: absolute;
        margin-top: 274px;
    }
    .hat{
    position: absolute;
        margin-top: 300px;
    }
    .kapadeti{
    position: absolute;
        margin-top: 324px;
    }
    .kg{
    position: absolute;
        margin-top: 348px;
    }
    .yukcins{
    position: absolute;
        margin-top: 372px;
    }
    .tur{
    position: absolute;
        margin-top: 396px;
        margin-left: 357px;
    }
    .toplam{
    position: absolute;
        margin-top: 250px;
        margin-left: 390px;
    }
    .tutar{
    position: absolute;
        margin-top: 274px;
        margin-left: 390px;
    }
    .rezervazyon{
    position: absolute;
        margin-top: 298px;
        margin-left: 390px;
    }
    .ceza{
    position: absolute;
        margin-top: 322px;
        margin-left: 390px;
    }
    .yolgecisucreti{
    position: absolute;
        margin-top: 346px;
        margin-left: 390px;
    }
    .sigorta{
    position: absolute;
        margin-top: 370px;
        margin-left: 390px;
    }
    .aciklama{
    position: absolute;
        margin-top: 440px;
    }
    .enalt{
    position: absolute;
        margin-top: 474px;
    }
    .left
    {
        float: left;
    }
    .border
    {
        border: solid 1px #000;
        padding: 2px;
    }
    .width80{
        width: 80px;
    }
    .width50{
        width: 50px;
    }
    .width100{
        width: 100px;
    }
    .width140{
        width: 140px;
        min-height: 15px;  
    }
    .width150{
        width: 150px;
        min-height: 15px;  
    }
    .width200{
        width: 200px;
    }
    .width580{
        width: 580px;
            min-height: 15px;   
    }
    .width340{
        width: 340px;
        font-size: 10px;
    }
</style>
<head>
    <title>Print</title>
</head>
<body onload="window.print()" >
<div>
    <div class="header left">
        <div class="logo left">
            <img src="/thema/tema1/dist/img/makbuzlogo.png">
        </div>
        <div class="title left"> TAHSİLAT MAKBUZU</div>
        <div class="years20">
            <img src="/thema/tema1/dist/img/20years.png">
            <div style="margin-left: -60px;" ><div class="left tarih border width50">TARİH</div><div class="tarihsag left border width140">` + tarih + `</div></div>
        </div>
    </div>
    <div class="content left">
        <div>
            <div class="firma left"><div class="left tarih border width140">FİRMA</div><div class="tarihsag left border width150">` + firma + `</div></div>
            <div class="left plaka"> <div class="left tarih border width140">PLAKA</div><div class="tarihsag left border width150">` + plaka + ` </div></div>
            <div class="left toplam"> <div class="left tarih border width140">GELDİGİ GÜMRÜK</div><div class="tarihsag left border width150">` + geldigigumrukStr + ` </div></div>
            <div class="left tutar"> <div class="left tarih border width140">TT NUMARASI</div><div class="tarihsag left border width150">` + ttnumarasi + `</div></div>
            <div class="left rezervazyon"> <div class="left tarih border width140">SURUCU ADI</div><div class="tarihsag left border width150">` + surucuadi + ` </div></div>
            <div class="left ceza"> <div class="left tarih border width140">KARNE NUMARASI</div><div class="tarihsag left border width150">` + karnenumarasi + ` </div></div>
            <div class="left yolgecisucreti"> <div class="left tarih border width140">PASAPORT NUMARASI</div><div class="tarihsag left border width150">` + pasaportnumarasi + ` </div></div>
            <div class="left sigorta"> <div class="left tarih border width140">GEMİ ADI</div><div class="tarihsag left border width150">` + gemiadi + ` </div></div>
            <div class="left hat"> <div class="left tarih border width140">HAT:</div><div class="tarihsag left border width150">` + gidecegiUlkeStr + `</div></div>
            <div class="left kapadeti"> <div class="left tarih border width140">KAP ADETİ:</div><div class="tarihsag left border width150">` + kapadeti + `</div></div>
            <div class="left kg"> <div class="left tarih border width140">KG:</div><div class="tarihsag left border width150">` + kg + `</div></div>
            <div class="left yukcins"> <div class="left tarih border width140">YUK CİNSİ:</div><div class="tarihsag left border width150">` + yukcins + `</div></div>
            <div class="left aciklama"> <div class="left tarih border width100">AÇIKLAMA</div><div class="tarihsag left border width580">` + this.state.aciklama + `</div></div>
            <div class="left enalt"> <div class="left tarih border width340">Aydıntepe Mah. 100.Yıl cad. No:12/33 P:Code: 34947 Tuzla/İstanbul</div><div class="tarihsag left border width340">ucarsoy@gmail.com | www.ucarsoy.com</div></div>
    </div>
        <div>
</div>
</div>
</div>
</body>

</html>
  
    `);
                popupWin.document.close();
            }).catch(res => {
        });

        /*window.history.back();*/
        /*window.disableModal();*/
        /*axios({
            method: 'post',
            url: Properties.baseUrl + '/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                window.successful((this.state.showDuzenle ? "Makbuz Güncellendi." : "Makbuz Kaydedildi"));
            }).catch(res => {
            window.unsuccessful((this.state.showDuzenle ? "Makbuz Güncellenemedi." : "Makbuz Kaydedilemedi."));
        });*/
    }

    cikis = e => {
        window.disableModal();
    }
    tasimaSave = e => {
        let status = true;
        if (status) {
            axios({
                method: 'post',
                url: Properties.baseUrl + '/tasima/saveEkBilgi',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                data: {
                    surucuAdi: this.state.surucuAdi ? this.state.surucuAdi.toUpperCase() : '',

                    karneNumarasi: this.state.karneNumarasi ? this.state.karneNumarasi.toUpperCase() : '',

                    pasaportNumarasi: this.state.pasaportNumarasi ? this.state.pasaportNumarasi.toUpperCase() : '',

                    geldigiGumruk: this.state.geldigiGumruk,

                    gemiAdi: this.state.gemiAdi ? this.state.gemiAdi.toUpperCase() : '',

                    ttNumarasi: this.state.ttNumarasi ? this.state.ttNumarasi.toUpperCase() : '',

                    kapAdeti: this.state.kapAdeti ? this.state.kapAdeti : '',

                    gidecegiUlke: this.state.gidecegiUlke ? this.state.gidecegiUlke : '',

                    kg: this.state.kg ? this.state.kg : '',

                    yukCinsi: this.state.yukCinsi ? this.state.yukCinsi.toUpperCase() : '',

                    durum: 2,

                    tasimaId: this.state.tasimaId ? this.state.tasimaId : '',

                }
            })
                .then(res => {
                    window.successful((this.state.showDuzenle ? "Ek Bilgi Güncellendi." : "Ek Bilgi Kaydedildi"));
                }).catch(res => {
            });
        }
    }
    get = e => {
        let status = true;
        if (status) {
            axios({
                method: 'get',
                url: Properties.baseUrl + '/tasima/get/' + this.state.tasimaId,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            })
                .then(res => {
                    this.setState({surucuAdi: res.data.surucuAdi});
                    this.setState({karneNumarasi: res.data.karneNumarasi});
                    this.setState({pasaportNumarasi: res.data.pasaportNumarasi});
                    this.setState({geldigiGumruk: res.data.geldigiGumruk});
                    this.setState({gidecegiUlke: res.data.gidecegiUlke});
                    this.setState({ttNumarasi: res.data.ttNumarasi});
                    this.setState({gemiAdi: res.data.gemiAdi});
                    this.setState({yukCinsi: res.data.yukCinsi});
                    this.setState({kapAdeti: res.data.kapAdeti});
                    this.setState({kg: res.data.kg});
                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Ek Bilgi Güncellenemedi." : "Ek Bilgi Kaydedilemedi."));
            });
        }
    }
    geri = () => {
        window.history.back();
    }
    onChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }

    render() {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
                    <form>
                        <div className="card-body">

                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">Sürücü Adı</label>
                                <input type="text" className="form-control" name="surucuAdi"
                                       onChange={this.onChange} value={this.state.surucuAdi}
                                       placeholder="Sürücü Adı"/>
                            </div>
                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">Pasaport Numarası</label>
                                <input type="text" className="form-control" name="pasaportNumarasi"
                                       onChange={this.onChange} value={this.state.pasaportNumarasi}
                                       placeholder="Pasaport Numarası"/>
                            </div>
                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">Gemi Adı</label>
                                <input type="text" className="form-control" name="gemiAdi" onChange={this.onChange}
                                       value={this.state.gemiAdi}
                                       placeholder="Gemi Adı"/>
                            </div>
                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">TT Numarası</label>
                                <input type="text" className="form-control" name="ttNumarasi"
                                       onChange={this.onChange} value={this.state.ttNumarasi}
                                       placeholder="TT Numarası"/>
                            </div>
                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">Karne Numarası</label>
                                <input type="text" className="form-control" name="karneNumarasi"
                                       onChange={this.onChange} value={this.state.karneNumarasi}
                                       placeholder="Karne Numarası"/>
                            </div>
                            <div className="col-12" style={{"display": "none"}}>
                                <label>Gideceği Ülke</label>
                                <select name="gidecegiUlke" className="form-control select2"
                                        onChange={this.onChange} value={this.state.gidecegiUlke}>
                                    <option value={0} selected="selected">Tür Seç</option>
                                    <option value={1}>TRİESTE</option>
                                    <option value={2}>BARİ</option>
                                </select>
                            </div>
                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">Geldiği Gümrük</label>
                                <select name="geldigiGumruk" className="form-control select2"
                                        onChange={this.onChange} value={this.state.geldigiGumruk}>
                                    <option value={0} selected="selected">Tür Seç</option>
                                    <option value={1}>ESENDERE</option>
                                    <option value={2}>DİLUCU</option>
                                    <option value={3}>GÜRBULAK</option>
                                </select>
                            </div>
                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">Kap Adeti</label>
                                <input type="text" className="form-control" name="kapAdeti" onChange={this.onChange}
                                       value={this.state.kapAdeti}
                                       placeholder="Kap Adeti"/>
                            </div>
                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">KG</label>
                                <input type="text" className="form-control" name="kg" onChange={this.onChange}
                                       value={this.state.kg}
                                       placeholder="KG"/>
                            </div>
                            <div className="col-12">
                                <label htmlFor="exampleInputEmail1">Yük Cinsi</label>
                                <input type="text" className="form-control" name="yukCinsi" onChange={this.onChange}
                                       value={this.state.yukCinsi}
                                       placeholder="Yük Cinsi"/>
                            </div>
                            <div className="col-12">
                                <button type="button"
                                        className="btn btn-block btn-outline-primary"
                                        onClick={e => this.makbuzYazdir()}
                                ><i className="fas fa-print"></i>
                                </button>
                            </div>
                        </div>
                        <div className=" row">
                            <div className="col-6">
                                <button type="button"
                                        onClick={this.tasimaSave}
                                        className="btn btn-block btn-primary">Kaydet
                                </button>
                            </div>
                            <div className="col-6">
                            <button type="button" onClick={e => this.cikis(e)}
                                        className="btn btn-block btn-outline-info">Çıkış
                                </button>
                            </div>
                        </div>

                    </form>);
    }
}


export default withRouter(BilgiGirisPopup);
